import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useMemo, useState } from 'react';
export var useMegaMenuItem = function useMegaMenuItem(props) {
  var category = props.category,
      activeCategoryId = props.activeCategoryId,
      subMenuState = props.subMenuState,
      disableFocus = props.disableFocus;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFocused = _useState2[0],
      setIsFocused = _useState2[1];

  var isActive = category.id === activeCategoryId;
  var handleMenuItemFocus = useCallback(function () {
    setIsFocused(true);
  }, [setIsFocused]);
  var handleCloseSubMenu = useCallback(function () {
    setIsFocused(false);
  }, [setIsFocused]);
  var isMenuActive = useMemo(function () {
    if (!isFocused) {
      return false;
    }

    if (subMenuState) {
      return true;
    } else if (disableFocus) {
      setIsFocused(false);
    }

    return false;
  }, [isFocused, subMenuState, disableFocus]);
  var handleKeyDown = useCallback(function (event) {
    var pressedKey = event.key,
        shiftKey = event.shiftKey; // checking down arrow and spacebar

    if (pressedKey === 'ArrowDown' || pressedKey === ' ') {
      event.preventDefault();

      if (category.children.length) {
        setIsFocused(true);
      } else {
        setIsFocused(false);
      }

      return;
    } //checking up arrow or escape


    if (pressedKey === 'ArrowUp' || pressedKey === 'Escape') {
      setIsFocused(false);
    } //checking Tab with Shift


    if (shiftKey && pressedKey === 'Tab') {
      setIsFocused(false);
    }
  }, [category.children.length]);
  return {
    isFocused: isFocused,
    isActive: isActive,
    handleMenuItemFocus: handleMenuItemFocus,
    handleCloseSubMenu: handleCloseSubMenu,
    isMenuActive: isMenuActive,
    handleKeyDown: handleKeyDown
  };
};